export function sessionRemoveItem(key) {
  sessionStorage.removeItem(key)
}

export function sessionRemoveAll() {
  console.log('Clear session start ...')
  sessionStorage.clear()
  console.log('Clear session End ...')
}

export function sessionSetItemStr(key, str) {
  sessionStorage.setItem(key, str)
}

export function sessionGetItemStr(key, str) {
  return sessionStorage.getItem(key, str)
}

export function sessionSetItemObj(key, jsonData) {
  sessionStorage.setItem(key, JSON.stringify(jsonData))
}

export function sessionGetItemObj(key) {
  const data = sessionStorage.getItem(key)
  return data ? JSON.parse(data) : {}
}

export function sessionGetItemJSON(key) {
  const data = sessionStorage.getItem(key)
  return data ? JSON.parse(data) : null
}
